import ClientPortalReportsRoutes from './ClientPortalReportsRoutes';

export default ClientPortalReportsRoutes;
